import type { TranslateService } from '@ngx-translate/core';
import type { WhispRiskPart } from '../../model';

const INDICATOR_KEY_PREFIX = 'whisp_indicator_';

export function whispIndicatorLabels(parts: WhispRiskPart[], translate: Pick<TranslateService, 'instant'>): string[] {
  const raised = parts.flatMap((part) =>
    Object.entries(part.indicators ?? {})
      .filter(([, on]) => on)
      .map(([key]) => key)
  );
  return [...new Set(raised)].map((key) => indicatorLabel(key, translate));
}

function indicatorLabel(key: string, translate: Pick<TranslateService, 'instant'>): string {
  const translationKey = `${INDICATOR_KEY_PREFIX}${key}_tr`;
  const label = translate.instant(translationKey);
  return label === translationKey ? key : label;
}
